import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, PasswordInput, Select } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { saveAdminUser, updateAdminUser, getTenants } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';

const AdminUserForm = ({ closeModal, isEdit, user }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const [tenants, setTenants] = useState([]);
	const form = useForm({
		initialValues: {
			name: '',
			email: '',
			password: '',
			tenant: {
				id: 0,
			},
		},
		validate: {
			name: (value) => value.length >= 4 ? null : 'El nombre debe de contener al menos 4 caracteres.',
			password: (value) => (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\W_ ]).{8,}$/.test(value) ? null : 'La contraseña debe de contener al menos 4 caracteres, 1 número, 1 mayúscula y 1 minúscula.'),
		}
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			name: user.name,
			email: user.email,
			password: user.password,
			tenant: {
				id: user.tenant?.id,
			},
		});
		// eslint-disable-next-line
	}, []);

	// On load
	useEffect(() => {

		// Get tenants
		getTenants(function (response) {

			// Loop tenants
			var tenants = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				tenants.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setTenants(tenants);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveAdminUser(values, function () {

				// Show success
				notifications.show({
					title: 'Usuario creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateAdminUser(user.id, values, function () {

				// Show success
				notifications.show({
					title: 'Usuario modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form
				onSubmit={form.onSubmit(onSubmit)}
				autoComplete="new-password"
			>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información de Usuario
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* Name */}
					<TextInput
						label="Nombre"
						placeholder="Nombre del usuario"
						value={form.values.name}
						onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
						{...form.getInputProps('name')}
						withAsterisk
					/>
					{/* Email */}
					<TextInput
						label="Correo Electrónico"
						placeholder="Correo electrónico del usuario"
						value={form.values.email}
						onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
						{...form.getInputProps('email')}
						withAsterisk
						autoComplete="new-password"
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Password */}
					<PasswordInput
						label="Contraseña"
						placeholder="Contraseña del usuario"
						value={form.values.password}
						onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
						{...form.getInputProps('password')}
						withAsterisk
						autoComplete="new-password"
					/>
					{/* Partner ID */}
					<Select
						searchable
						withinPortal
						label="Partner"
						placeholder="Busca un partner"
						value={form.values.tenant.id}
						onChange={(event) => form.setFieldValue('tenant.id', event.currentTarget.value)}
						{...form.getInputProps('tenant.id')}
						nothingFound="Sin resultados"
						data={tenants}
						withAsterisk
						autoComplete="new-password"
					/>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Usuario'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default AdminUserForm;
